// ==============================================================================
// COMPONENTE PRINCIPAL QUE SELECCIONA EL DASHBOARD
// ==============================================================================

// src/components/dashboard/DashboardSelector.js
import React from 'react';
import { 
  Alert, 
  Container, 
  Grid, 
  Card, 
  CardHeader, 
  CardContent, 
  Skeleton,
  Typography
} from '@mui/material';

// Importar todos los dashboards
import { AdminDashboard } from './AdminDashboard';
import { OrganizerDashboard } from './OrganizerDashboard';
import { CoachDashboard } from './CoachDashboard';
import { AthleteDashboard } from './AthleteDashboard';
import { BaseDashboard } from './BaseDashboard';

// Componente de loading
const DashboardLoading = () => (
  <Container maxWidth="xl" sx={{ py: 4 }}>
    <Grid container spacing={3}>
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <Grid item xs={12} md={6} lg={4} key={item}>
          <Card>
            <CardHeader
              avatar={<Skeleton variant="circular" width={40} height={40} />}
              title={<Skeleton variant="text" width="60%" />}
              subheader={<Skeleton variant="text" width="40%" />}
            />
            <CardContent>
              <Skeleton variant="rectangular" height={150} />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Container>
);

export const DashboardSelector = ({ 
  user, 
  userRole, 
  onWidgetsChange, 
  dashboardData,
  loading = false 
}) => {
  const dashboardComponents = {
    // Admin
    admin: AdminDashboard,
    administrador: AdminDashboard,
    
    // Organizador
    organizador: OrganizerDashboard,
    organizer: OrganizerDashboard,
    
    // Entrenador
    entrenador: CoachDashboard,
    coach: CoachDashboard,
    
    // Atleta
    atleta: AthleteDashboard,
    athlete: AthleteDashboard,
    
    // Cronometrador (placeholder por ahora)
    cronometrador: null,
    timekeeper: null,
    
    // Juez (placeholder por ahora)
    juez: null,
    judge: null,
    
    // Medios (placeholder por ahora)
    medios: null,
    media: null
  };

  // Mostrar loading si está cargando
  if (loading) {
    return <DashboardLoading />;
  }

  const DashboardComponent = dashboardComponents[userRole?.toLowerCase()];
  
  if (!DashboardComponent) {
    return (
      <BaseDashboard
        role={userRole}
        user={user}
        widgets={[]}
        title={`Dashboard ${userRole}`}
        subtitle="Dashboard en desarrollo"
        roleIcon="⚠️"
        roleColor="warning"
        onWidgetsChange={onWidgetsChange}
        showEditMode={false}
      >
        <Alert severity="info" sx={{ mb: 3 }}>
          El dashboard para el rol "<strong>{userRole}</strong>" está en desarrollo.
          <br />
          Próximamente tendrás acceso a widgets específicos para tu rol.
        </Alert>
        
        <Alert severity="warning" sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Roles disponibles actualmente:
          </Typography>
          <Typography variant="body2">
            • <strong>Administrador</strong> - Control total del sistema<br />
            • <strong>Organizador</strong> - Gestión de eventos<br />
            • <strong>Entrenador</strong> - Seguimiento de atletas<br />
            • <strong>Atleta</strong> - Panel personal
          </Typography>
        </Alert>
      </BaseDashboard>
    );
  }

  return (
    <DashboardComponent 
      user={user} 
      onWidgetsChange={onWidgetsChange}
      dashboardData={dashboardData}
      loading={loading}
    />
  );
};

export default DashboardSelector;